import { type ChainflipAsset } from '@chainflip/utils/chainflip';

export const lendingPoolColors = {
  Sol: '#C9A8FF', // cf-blue-4
  Eth: '#1B76FF', // cf-blue-1
  Btc: '#F4BD8A', // ???
} as Record<ChainflipAsset, string>;
